import styled from 'styled-components'
import { Flex } from 'reflexbox'

export const AddInputsButton = styled.button`
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.grays.N800};
  border: none;
  background: transparent;
  margin-bottom: 40px;
  align-self: flex-start;
  cursor: pointer;
`

export const RemoveInputsButton = styled.button`
  border: none;
  background: transparent;
  width: auto;
  height: auto;
  position: absolute;
  cursor: pointer;
  right: 0px;
`

export const OrderInputsContainer = styled(Flex)`
  position: relative;
`
